import { z } from "zod";
import { DateValidation } from "../shared/date-validation";

export const SupportCaseCommentItemSchema = z.object({
  Id: z.string().uuid(),
  Subject: z.string().optional(),
  Text: z.string().optional(),
  OwnerId: z.string().uuid().optional(),
  StatusCode: z.number().int().optional(),
  ActivityTypeCode: z.number().int().optional(),
  Created: DateValidation.optional(),
});

export type SupportCaseCommentItemType = z.infer<
  typeof SupportCaseCommentItemSchema
>;
